/**
 * timeline scroll effect
 */
let timelineEntries = [];
let timelineAutoScrolling = false;

window.addEventListener("DOMContentLoaded", function() {
  timelineEntries = document.querySelectorAll(".timeline-item");
  if (timelineEntries.length) {
    initTimeline();
  }
});

function initTimeline() {
  console.log('Timeline init...');
  timelineEntries[0].style.borderWidth = '0'; // remove timeline border from first item on top
  window.addEventListener("resize", timelineItemTransitions);
  window.addEventListener("scroll", timelineItemTransitions);
  generateTimelineSummary();
  timelineItemTransitions();
}

/**
 * generate an array of unique year => dom id combinations (always first timeline entry per year)
 *
 */
var years = [];
function generateTimelineSummary() {
  var numeric = /^[0-9]+$/;

  for (var i = 0; i < timelineEntries.length; i++) {
    var title = timelineEntries[i].querySelector('.timeline-title');
    if (title) {
      var year = title.innerHTML.trim();
      // empty year -> bruno's year "kachel"
      if (timelineEntries[i+1] && (!year || year == '')) {
        year = timelineEntries[i+1].querySelector('.timeline-title').innerHTML.trim();
      }
      if (year.length === 4 && numeric.test(year)) {
        var id = title.closest('.c-aggregator__item').dataset.id;
        // keep first value per year only
        if (!hasYearEntry(years, year)) {
          years.push({
            year: year,
            id: id
          });
        }
      }
    }
  }

  // prepare the dom elemnt with the year summaries
  var summary = document.createElement("div");
  summary.classList.add('timeline-summary');

  for (i = 0; i < years.length; i++) {
    var entry = document.createElement("div");
    entry.classList.add('timeline-summary__entry');
    entry.classList.add('timeline-summary__entry--'+years[i].year);
    var text = document.createTextNode(years[i].year);
    entry.appendChild(text);
    entry.dataset.itemid = years[i].id;
    summary.append(entry);

    entry.addEventListener('click', function () { // jshint ignore:line
      var target = $('[data-id="' + this.dataset.itemid + '"]').first();
      if (target.length) {
        // highlight current item (both in timeline and in summary)
        removeCurrentTimelineEntryHighlight();
        this.classList.add('current');
        var timeline_item = target.find('.timeline-item').first();
        timeline_item.addClass('current');

        // scroll to active item
        var offset = 0;
        timelineAutoScrolling = true;
        $('html,body').animate({
          scrollTop: (target.position().top - offset)
        }, 400, 'swing', function () {
          timelineAutoScrolling = false;
        });
      }
    });
  }

  // append summary to right column
  var column = document.querySelector('.i4-site .main');
  column.prepend(summary);

  // make summary to stick on scroll
  var el = $(summary);
  var initTopPosition = 85;
  $(window).scroll(function(){
    if($(window).scrollTop() > initTopPosition) {
      el.css({'position':'fixed'});
    } else {
      el.css({'position':'absolute','top':initTopPosition+'px'});
    }
  });
}

function removeCurrentTimelineEntryHighlight() {
  var summaryEntries = document.querySelectorAll('.timeline-summary__entry');
  for(var i = 0; i < summaryEntries.length; i++) {
    summaryEntries[i].classList.remove('current');
  }

  var timelineEntries = document.querySelectorAll('.timeline-item');
  for(i = 0; i < timelineEntries.length; i++) {
    timelineEntries[i].classList.remove('current');
  }
}

/**
 * check if years array already contains an entry for given year
 *
 * @param years
 * @param year
 * @returns {boolean}
 */
function hasYearEntry(years, year) {
  for(var i = 0; i < years.length; i++) {
    if (years[i].year === year) {
      return true;
    }
  }

  return false;
}

/**
 * check if a given element is in the viewport
 *
 * @param elem
 * @returns object
 */
function isOutOfViewport(elem) {
  // Get element's bounding
  var bounding = elem.getBoundingClientRect();

  // Check if it's out of the viewport on each side
  var out = {};
  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
  out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;
  out.all = out.top && out.left && out.bottom && out.right;

  return out;
}

/**
 * attache animation to currently scolled timeline item and prepare the following one
 *
 */
function timelineItemTransitions() {
  const minVisibleTimlineEntries = 2;

  var lastVisibleTimelineEntry = null;
  for (var i = 0; i < timelineEntries.length; i++) {
    if (i < minVisibleTimlineEntries || !isOutOfViewport(timelineEntries[i]).any) {
      timelineEntries[i].classList.add("active");
      if (typeof(timelineEntries[(i+1)]) != "undefined") {
        timelineEntries[(i+1)].classList.add("preactive");
      }

      lastVisibleTimelineEntry = timelineEntries[i];
    }
  }
  timelineSummaryScroll(lastVisibleTimelineEntry);
}

/**
 * function to highlight the proper year in the timeline summary
 * @param timelineEntry
 * @param force
 */
function timelineSummaryScroll(timelineEntry, force) {
  if (timelineAutoScrolling === false) {
    const bottomBoundReached = (timelineEntry.getBoundingClientRect().y) < 0;
    const timelineSummary = document.querySelector('.timeline-summary');
    var year = null;
    var title = timelineEntry.querySelector('.timeline-title');
    var timelineSummaryYearEntry = null;
    if (title) {
      if (bottomBoundReached) {
        year = 1991;
        timelineSummary.style.removeProperty('top');
        $(timelineSummary).css({
          bottom: "770px"
        });

      } else {
        year = title.innerHTML.trim();
        timelineSummary.style.removeProperty('bottom');
        $(timelineSummary).css({
          top: "104px"
        });
      }
      if (hasYearEntry(years, year)) {
        timelineSummaryYearEntry = document.querySelector('.timeline-summary__entry--' + year);
        if (timelineSummaryYearEntry) {
          removeCurrentTimelineEntryHighlight();
          $(timelineEntry).click(); // trick to remove the hover from previous element on touch devices
          timelineSummaryYearEntry.classList.add('current');
        }
      } else {
        var timelineNextEntry = null;
        try {
          timelineNextEntry = timelineEntry.closest('.c-aggregator__item--composition').nextElementSibling.querySelector('.timeline-item');
        } catch (e) {
          // ignore
        }
        if (timelineNextEntry) {
          title = timelineNextEntry.querySelector('.timeline-title');
          if (title) {
            if (bottomBoundReached) {
              year = 1991;
            } else {
              year = title.innerHTML.trim();
            }
            if (hasYearEntry(years, year)) {
              timelineSummaryYearEntry = document.querySelector('.timeline-summary__entry--' + year);
              if (timelineSummaryYearEntry) {
                removeCurrentTimelineEntryHighlight();
                $(timelineNextEntry).click(); // trick to remove the hover from previous element on touch devices
                timelineSummaryYearEntry.classList.add('current');
              }
            }
          }
        }
      }
    }
  }
}
